<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
        <a-col :span="6">
            <a-form-model-item label="门店选择">
              <a-select
                v-model="formInline.shopId"
                placeholder="请选择门店"
                style="width: 250px"
                allowClear
              >
                <a-select-option
                  v-for="item in storeList"
                  :key="item.storeId"
                  :value="item.storeId"
                >
                  {{ item.storeName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
        </a-col>
          <a-col :span="6">
            <a-form-model-item label="活动类型" prop="store">
              <a-select
                default-value=""
                style="width: 200px"
                v-model="formInline.operationType"
              >
                <a-select-option disabled="true"  value="">请选择操作类型</a-select-option>
                <a-select-option value="门票套餐修改">门票套餐修改</a-select-option>
                <a-select-option value="代币套餐修改">代币套餐修改</a-select-option>
                <a-select-option value="门票套餐新增">门票套餐新增</a-select-option>
                <a-select-option value="代币套餐新增">代币套餐新增</a-select-option>
                <a-select-option value="套餐上下架">套餐上下架</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-button type="primary" html-type="submit"> 查询 </a-button>
            </a-form-model-item>
            <a-form-model-item>
              <a-button style="margin-left: 10px" @click="resetForm">
                重置
              </a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
        <packageLogContent
          ref="aaa"
          :formInline="formInline"
        ></packageLogContent>
      </div>
    </a-layout-content>
<!--     <memberManagementContent></memberManagementContent>-->
  </div>
</template>

<script>
import { getStoreList } from "@/api/homeApi";
import packageLogContent from "./packageLogContent.vue";
export default {
  components: {
    packageLogContent,
  },
  data() {
    return {
      formInline: {
        operationType: "",
        limit: 10,
        page: 1,
        shopId:null
      },
      storeList:[]
    };
    
  },
  mounted() {
    this.getstoresData();
  },
  methods: {

     getstoresData() {
      getStoreList().then((res) => {
        if(res.data){
          this.storeList = res.data;
        }
      });
    },
    handleSubmit(e) {
      console.log(this.formInline);
      this.$refs.aaa.query();
    },
    resetForm() {
      this.formInline = {
        operationType: "",
        limit: 10,
        page: 1,
        shopId:null
      };
      setTimeout(()=>{
        this.$refs.aaa.getTokensListData();
      },200)

    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/marketingManagement/packageLogAdmin/packageLogHome.vue